// extracted by mini-css-extract-plugin
export default {"loader":"BankWithdraw_loader__Fl1NG","noData":"BankWithdraw_noData__rs0Tc"};